import settings from './config/settings';
import Router from './utilities/Router';
import Ajaxify from './libaries/ajaxify';

import navigation from './components/navigation';
import cookiePrivacy from './components/cookiePrivacy';

import common from './routes/common';
import pageLanguage from './routes/pageLanguage';

// Things we are only setting up once per page refresh.

// setup navigation
navigation.init();

// setup cookie privacy box
cookiePrivacy.init();

function updateDesktopMenu(url) {
  const urlNoProtocol = url.replace(/(^\w+:|^)\/\//, '').split('#')[0];

  // Update the menu
  const activeClass = 'is-active';
  const menuTopListDesktopQuery = '.js-nav > .nav__list > .nav__item';

  // check to see if page is part of the main menu.
  const $menuTopList = document.querySelectorAll(menuTopListDesktopQuery);
  for (let i = 0; i < $menuTopList.length; i += 1) {
    const $menuTopItem = $menuTopList[i];
    $menuTopItem.classList.remove(activeClass);

    const $menuLinks = $menuTopItem.querySelectorAll('a');
    for (let j = 0; j < $menuLinks.length; j += 1) {
      const $menuLink = $menuLinks[j];
      // remove protocol and hash from href.
      const hrefNoProtocol = $menuLink.getAttribute('href').replace(/(^\w+:|^)\/\//, '').split('#')[0];

      if (urlNoProtocol === hrefNoProtocol) {
        $menuTopItem.classList.add(activeClass);
      }
    }
  }
}

function updateMobileMenu(url) {
  const urlNoProtocol = url.replace(/(^\w+:|^)\/\//, '').split('#')[0];

  // mobile menu
  const activeClass = 'is-active';
  const menuTopListMobileQuery = '.js-mobile-nav .mobile-nav__list > .js-accordion';
  const $menuTopList = document.querySelectorAll(menuTopListMobileQuery);
  for (let i = 0; i < $menuTopList.length; i += 1) {
    const $menuTopItem = $menuTopList[i];

    // find Button
    const $menuTopItemButton = $menuTopItem.querySelector('button');
    $menuTopItemButton.classList.remove(activeClass);

    const $menuLinks = $menuTopItem.querySelectorAll('a');
    for (let j = 0; j < $menuLinks.length; j += 1) {
      const $menuLink = $menuLinks[j];
      // remove protocol and hash from href.
      const hrefNoProtocol = $menuLink.getAttribute('href').replace(/(^\w+:|^)\/\//, '').split('#')[0];

      if (urlNoProtocol === hrefNoProtocol) {
        $menuTopItemButton.classList.add(activeClass);
        $menuLink.classList.add(activeClass);
      } else {
        $menuLink.classList.remove(activeClass);
      }
    }
  }
}

// setup ajaxify
if (settings.useAjaxify) {
  // eslint-disable-next-line no-unused-vars
  const ajaxifyInstance = new Ajaxify(
    (url) => {
      // unbind events javascript before sceen change.
      window.routes.unload();

      updateDesktopMenu(url);
      updateMobileMenu(url);

      navigation.close();
    },
    () => {
      // bind events to new content.
      window.routes.reload();
    },
  );
}

/** Populate Router instance with DOM routes */
window.routes = new Router({
  // All pages
  common,

  // pages
  pageLanguage,
  // home,
  // adiosAle,
  // error404,
  // pageTemplateCareers: careers,
});

// Load Events
window.routes.loadEvents();
